module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADWSURBVHgB3ZK7CsJAEEXvTmRFXBSFgC+0ECxSKWphIfgNgt9saZXOSkVSRQwRQfCRiCyJmaBl9FSzpxh2Lhf4WwzWWpZEvjtCsWPA3x61b0wGUB0Zcy9y7KJDoQZBFsS9Frw2T2eOg1n0QTdfu4+LKmcHnrRxJUc78+TCK9vB5OInEKw1LQWjNAUJB/vlKtVFIHZRrlAFURhuW7s8ZMJ9RX3YhjlTCVeaVJEdwqKmwDc7DLbcW0A1W/B3a+0ulXnMReDDRlEFrZasI0r9FU94xvspnMssD86HLt9WotS3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-grip.png
// module id = 1064
// module chunks = 0